import { Api } from "./Api";
import { apiUrl } from "../enviroments/enviroments.dev";
import {
  CreateDepositAccountDto,
  DepositAccount,
  DepositAccountFormOptions,
} from "../models/DepositAccount";

const target = "/deposit-accounts";

export class DepositAccountService {
  // Contas de deposito de uma organizacao.
  public static getByOrganization(orgId: number): Promise<DepositAccount[]> {
    return Api.get(apiUrl(target + "/organization/" + orgId));
  }

  // Bancos + redes para popular os dropdowns do modal.
  public static getFormOptions(): Promise<DepositAccountFormOptions> {
    return Api.get(apiUrl(target + "/form-options"));
  }

  public static create(
    orgId: number,
    payload: CreateDepositAccountDto,
  ): Promise<DepositAccount> {
    return Api.post(apiUrl(target + "/organization/" + orgId), payload);
  }
}
